import React from 'react';

const SharePoint = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 48 48"
    strokeWidth={2}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m4.55,16v16c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-16c0-1.1-.9-2-2-2H6.55c-1.1,0-2,.9-2,2Z" />
    <path d="m11.15,28.3c.7.9,1.5,1.2,2.7,1.2h1.6c1.5,0,2.7-1.2,2.7-2.7h0c0-1.5-1.2-2.7-2.7-2.7h-1.8c-1.5,0-2.7-1.2-2.7-2.7h0c0-1.5,1.2-2.8,2.8-2.8h1.6c1.2,0,2,.3,2.7,1.2" />
    <path d="m32.45,35.6c.4.1.9.1,1.3.1,5.4,0,9.7-4.4,9.7-9.7s-4.4-9.7-9.7-9.7c-4.3,0-8,2.8-9.2,6.7" />
    <path d="m24.55,26.5c4.4,0,8,3.6,8,8,0,.4,0,.8-.1,1.1-.6,3.9-3.9,6.9-7.9,6.9-4.4,0-8-3.6-8-8v-.5" />
    <path d="m12.85,14c1-4.9,5.4-8.5,10.5-8.5,5.9,0,10.8,4.8,10.8,10.7" />
  </svg>
);

export default SharePoint;